














































import { emit } from 'cluster';
import { ColorsList } from '../../../features/core/utils/type-colors';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import LoadingIndicator from '../../../features/core/components/LoadingIndicator.vue';
import { AuthStoreHelper, RootStoreHelper } from '../../../features/core/mixins';
@Component({
    components: {
      LoadingIndicator
    }
})
export default class ChatbotClearMessagesDialog extends Mixins(RootStoreHelper, AuthStoreHelper) {
  loadingTextColor: string = ColorsList.navy_blue;
   dialog: boolean = true;

  @Emit()
  userConfirmedDeleteConversation(){}

  @Emit()
  closeModal(){}

   onUserResponse(action: boolean){
    if(action){
      this.userConfirmedDeleteConversation();
    }else{
      this.closeModal();
    }
   }
}
